import { render, staticRenderFns } from "./PedidosModo.vue?vue&type=template&id=2a6c8508"
import script from "./PedidosModo.vue?vue&type=script&lang=js"
export * from "./PedidosModo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports